export default __webpack_public_path__ + "static/media/hugo-bouthiette.55ff71de.jpg";